export default "__VITE_PUBLIC_ASSET__ea3b2cf0__"